import ApiService from '@/services/core/api.service'

const RawDataService = {
  async get (query) {
    return ApiService.get(`user/raw-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/raw-data', payload)
  },

  async put (payload) {
    return ApiService.put(`user/raw-data/${payload.id}`, payload)
  }
}

export default RawDataService
